module.exports = __webpack_public_path__ + "img/digibox-logo.b468a7b9.png";